import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const AdultLearnerIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 999.7 1000"
      role="img"
    >
      <title>{educationLevels().level2.label}</title>
      <path
        d="M13,946H440.69a13,13,0,0,0,2,.72l369.46,53.05a65.73,65.73,0,0,0,74.47-55.55L999.53,163.92a65.58,65.58,0,0,0-55.72-74.25L721.51,57.75A67,67,0,0,0,655.37.4H13A12.5,12.5,0,0,0,.52,12.89V933.45A12.5,12.5,0,0,0,13,946Zm79.81-600.2H25.51V253.59H92.83Zm0,25v92.16H25.51V370.75Zm0,117.15v92.16H25.51V487.9Zm0,117.15v92.16H25.51V605.05Zm0,117.15v92.16H25.51V722.2Zm0-493.6H25.51V136.44H92.83ZM25.51,839.36H92.83V921H25.51Zm941.6-709.08a40.18,40.18,0,0,1,7.69,30.07L861.93,940.6A40.8,40.8,0,0,1,815.75,975L613.53,946h41.85a67.19,67.19,0,0,0,67.11-67.12V474.74l108.76,15.62a12.11,12.11,0,0,0,1.8.13,12.49,12.49,0,0,0,12.34-10.71l29-200.52a12.5,12.5,0,0,0-10.6-14.16L722.49,244.82V83.15l217.77,31.26A40.6,40.6,0,0,1,967.11,130.28ZM722.5,404.05l27.62,4a12.11,12.11,0,0,0,1.8.13,12.5,12.5,0,0,0,1.75-24.87l-31.18-4.48V340.74L759.08,346a12.11,12.11,0,0,0,1.8.13,12.5,12.5,0,0,0,1.75-24.87l-40.14-5.77V270l125.38,18L822.44,463.82l-100-14.35V404.05Zm-25-336.54V878.83A42.18,42.18,0,0,1,655.39,921H117.82V25.39H655.39A42.16,42.16,0,0,1,697.51,67.51ZM92.83,25.39v86.05H25.51v-86Z"
        transform="translate(-0.52 -0.4)"
      />
      <path
        d="M242,424.31H554.87a12.5,12.5,0,0,0,12.49-12.5V203.31a12.5,12.5,0,0,0-12.49-12.5H242a12.5,12.5,0,0,0-12.49,12.5v208.5A12.5,12.5,0,0,0,242,424.31Zm12.5-208.5H542.37v183.5H254.52Z"
        transform="translate(-0.52 -0.4)"
      />
      <path
        d="M475.42,262.82H321.48a12.5,12.5,0,1,0,0,25H475.42a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-0.52 -0.4)"
      />
      <path
        d="M475.42,327.3H321.48a12.5,12.5,0,1,0,0,25H475.42a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-0.52 -0.4)"
      />
    </svg>
  );
};

export default AdultLearnerIcon;

AdultLearnerIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
